import { useEffect, useState } from "react";
import { IRBDItem } from "../../../models/rbd";
import { IDiagramValues } from "./Diagram";
import { 
    isSerialTransmission, 
    isElement, 
    isParalelTransmission, 
    isRedundantTransmission 
} from './helper/validator';
import { handleElement } from "./handler/element.handler";
import { handleSerial } from "./handler/serial.handler";
import { handleParalel } from './handler/paralel.handler';
import { handleRedundant } from "./handler/redundant.handler";
import { useStore } from "../../../stores/store";

function handleValue(rbdItem: IRBDItem[]): IDiagramValues[] {
    let prev: IRBDItem | undefined;
    const visibles: IRBDItem[] = [];
    const result: IDiagramValues[] = [];
    
    rbdItem.forEach(i => !i.isGrouped && visibles.push(i))

    visibles.forEach((visible, index) => {
        prev = visibles[index - 1]

        if (isElement(visible)) {
            result.push(handleElement(visible, prev))
        } else if (isSerialTransmission(visible)) {
            result.push(...handleSerial(visible, prev))
        } else if (isParalelTransmission(visible)) {
            result.push(...handleParalel(visible, prev))
        } else if (isRedundantTransmission(visible)) {
            result.push(...handleRedundant(visible, prev))
        }
    })

    return result
}

export const useDiagram = (rbdItem: IRBDItem[]) => {
    const [value, setValue] = useState<IDiagramValues[]>([])
    const { injectDiagramValue, clearDiagram } = useStore().rbdStore
    
    useEffect(() => {
        setValue(handleValue(rbdItem))
    }, [rbdItem])

    useEffect(() => {
        injectDiagramValue(value)
        return () => clearDiagram()
    }, [value, clearDiagram, injectDiagramValue])

    return value
}
